<template>
  <div>
    <v-alert v-for="(message, messageKey) in messages" :key="`messages-${messageKey}`"
             :value="true"
             :color="message.color"
             :icon="message.icon"
             outlined
    >
      <span v-html="message.text"></span>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'Messages',
  props: {
    messages: {
      type: Array,
      required: true
    }
  },
  computed: {
    show () {
      return this.messages.length > 0
    }
  }
}
</script>
